import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { selectOngoingPlayerProfileInfo } from "../../selectors/selectOngoingPlayerProfileInfo";
import { selectPlayerInfo } from "../../selectors/selectPlayerInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../utils/i18n/ReplacementLoca";
import { DialogWrapper } from "../dialog/DialogWrapper";
import { ButtonDelete } from "../generic/common/ButtonDelete";
import { ButtonPrimary } from "../generic/common/ButtonPrimary";
import { TextLoca } from "../generic/text/TextLoca";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { actionCoopInfoKickMember } from "./actionCoop";
export var _DialogCoopKick = function (_a) {
    var onClose = _a.onClose, onClickKick = _a.onClickKick, coopId = _a.coopId, playerId = _a.playerId, playerNameToKick = _a.playerNameToKick, playerIdToKick = _a.playerIdToKick;
    var replacements = new Map([[ReplacementLoca.zero_0, playerNameToKick]]);
    return (React.createElement(DialogWrapper, { titleLocaId: IdLoca.kickMemberCoop_title, onClose: onClose, className: IdStyles.ModalBackgroundInfo + " DialogCoopConfirm" },
        React.createElement("div", { className: "w100 h100 flex flex--guts DialogCoopConfirm__content" },
            React.createElement("div", { className: "DialogCoopConfirm__question" },
                React.createElement(TextLoca, { className: IdStyles.TextNormal, id: IdLoca.kickMember_desc, replacements: replacements })),
            React.createElement("div", { className: "w100 DialogCoopConfirm__confirm-or-cancel" },
                React.createElement(ButtonDelete, { onClick: onClose },
                    React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.cancel })),
                React.createElement(ButtonPrimary, { onClick: function () { return onClickKick(playerId, coopId, playerIdToKick); } },
                    React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.kick }))))));
};
var mapState = function (state) {
    var current = selectPlayerInfo(state);
    var coopId = current.coopId, playerId = current.playerId;
    var toKick = selectOngoingPlayerProfileInfo(state);
    var playerIdToKick = toKick.id, playerNameToKick = toKick.name;
    return {
        coopId: coopId,
        playerId: playerId,
        playerIdToKick: playerIdToKick,
        playerNameToKick: playerNameToKick,
    };
};
var mapDispatch = function (dispatch) { return ({
    onClickKick: function (playerId, coopId, playerIdToKick) {
        dispatch(actionCoopInfoKickMember(playerId, coopId, playerIdToKick));
        dispatch(actionModalClose(IdModal.CoopKick));
        dispatch(actionModalClose(IdModal.PlayerProfile));
    },
    onClose: function () { return dispatch(actionModalClose(IdModal.CoopKick)); },
}); };
export var DialogCoopKick = connect(mapState, mapDispatch)(_DialogCoopKick);



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/DialogKick.tsx
// module id = 2571
// module chunks = 3